import { navigate } from "@gatsbyjs/reach-router";
import { actionsTableListType } from "customHooks/useCompleoSimpleList";
import { apiDirectCall } from "customHooks/useApi/api";
import { useGlobalDialog } from "_ReactContext/GlobalDialogContext";
import useShowMessage from "customHooks/useShowMessage/useShowMessage";

const useActionsTable = (companyId: number, t: any) => {
    const { callDialog } = useGlobalDialog();
    const showMessage = useShowMessage();

    return (refreshListFunction: any) => {
        const result: actionsTableListType = [
            {
                icon: "edit",
                tooltip: t("buttonEditWorkflow"),
                onClick: (event: any, rowData: any) => {
                    navigate(
                        `/jobapprovalworkflow/edit/${
                            rowData.skGS1pk.split(":")[1]
                        }`
                    );
                }
            },
            {
                icon: "delete",
                tooltip: t("buttonDeleteWorkflow"),
                onClick: async (event: any, rowData: any) => {
                    const uuid = rowData.skGS1pk.split(":")[1];
                    const postAddress = `/jobapprovalworkflow/delete`;

                    callDialog({
                        title: t("WorkflowDelete_ModalTitle"),
                        bodyText: t("WorkflowDelete_Message"),
                        agreeButtonText: t("WorkflowDelete_yes"),
                        disagreeButtonText: t("WorkflowDelete_no"),
                        agreeFunction: async () => {
                            const result = await apiDirectCall(
                                postAddress,
                                "post",
                                {
                                    companyId: companyId,
                                    uuid: uuid
                                }
                            );
                            if (result.status === 200) {
                                showMessage(
                                    t("WorkflowDelete_succesMessage"),
                                    "success"
                                );
                                refreshListFunction();
                                return true;
                            }
                            return false;
                        },
                        disagreeFunction: () => {
                            return false;
                        }
                    });
                }
            }
        ];

        return result;
    };
};

export default useActionsTable;
